import React, { useState, useEffect, useRef } from 'react';
import Layout from '../Layout/Layout.js';
import { APIUrl } from '../../Helper/APIUrl.js';
import { useSnackbar } from "notistack";
import { Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';

function AddFiletrationCategoryParentChild() {

    const Token = JSON.parse(localStorage.getItem('tcn'));
    const { enqueueSnackbar } = useSnackbar();

    const [zsection, setzsection] = useState([]);
    const [sztypes, setsztypes] = useState([]);
    const [savedMappings, setsavedMappings] = useState([]);

    const [selectedSection, setselectedSection] = useState("");
    const [selectedTypeIds, setselectedTypeIds] = useState([]);
    const [typeSearch, settypeSearch] = useState("");

    const ZSectionInputRef = useRef(null);

    const parseJSON = async (response) => {
        try {
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);
            return null;
        }
    }

    const getAllZSections = async () => {
        try {
            const response = await fetch(APIUrl.ZSections + 'GetAllZSections', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify()
            });

            const result = await parseJSON(response);

            if (result && result.data !== null) {
                let filterData = result.data.filter(x => x.PropertyCategoryTag === "FilterationCategory" && x.IsActive === true);
                setzsection(filterData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getAllSZTypes = async () => {
        try {
            const response = await fetch(APIUrl.SZType + 'GetAllSZType', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify()
            });

            const result = await parseJSON(response);
            if (result && result.data) {
                // normalize ids to numbers and keep only active types
                const normalized = result.data.map(x => ({
                    ...x,
                    TypeId: Number(x.TypeId),
                    SectionId: Number(x.SectionId),
                    IsActive: Boolean(x.IsActive)
                }));

                const active = normalized.filter(x => x.IsActive === true && (x.SectionId === 11 || x.SectionId === 12));
                setsztypes(active);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getAllZSections();
        getAllSZTypes();
    }, []);

    const visibleTypes = sztypes.filter(x =>
        (x.TypeName || "").toLowerCase().includes(typeSearch.toLowerCase())
    );

    const selectedSectionData = zsection.find(x => Number(x.SectionId) === Number(selectedSection));
    const selectedMappings = selectedTypeIds.map(typeId => {
        const typeData = sztypes.find(x => Number(x.TypeId) === Number(typeId));
        return {
            ParentId: Number(selectedSection),
            ParentName: selectedSectionData ? selectedSectionData.SectionName : "",
            ChildId: Number(typeId),
            ChildName: typeData ? typeData.TypeName : ""
        };
    });

    const toggleType = (typeId) => {
        setselectedTypeIds(prev => {
            if (prev.includes(typeId)) return prev.filter(x => x !== typeId);
            return [...prev, typeId];
        })
    }

    const submitMapping = async () => {
        try {
            if (!selectedSection) {
                enqueueSnackbar("Please select a Filteration Category", { variant: 'warning' });
                return;
            }
            if (!selectedTypeIds.length) {
                enqueueSnackbar("Please select at least one Type", { variant: 'warning' });
                return;
            }

            // Prevent submitting duplicate Parent+Child pairs
            const existingSet = new Set((categoryFilters || []).map(x => `${x.ParentId}_${x.ChildId}`));
            const savedSet = new Set((savedMappings || []).map(x => `${x.ParentId}_${x.ChildId}`));

            const selectedPairs = selectedTypeIds.map(id => ({ id: Number(id), key: `${Number(selectedSection)}_${Number(id)}` }));
            const duplicates = selectedPairs.filter(p => existingSet.has(p.key) || savedSet.has(p.key));
            const unique = selectedPairs.filter(p => !existingSet.has(p.key) && !savedSet.has(p.key)).map(p => p.id);

            if (unique.length === 0) {
                enqueueSnackbar('All selected mappings already exist; nothing to save.', { variant: 'warning' });
                return;
            }

            if (duplicates.length > 0) {
                enqueueSnackbar(`${duplicates.length} duplicate(s) skipped`, { variant: 'info' });
            }

            // Build payload expected by API: list of { ParentId, ChildId, CreatedBy, ModifyBy }
            const payload = unique.map(id => ({
                ParentId: Number(selectedSection),
                ChildId: Number(id),
                IsActive: true,
                CreatedBy: 1,
                CreatedOn: new Date(),
                ModifyBy: 1,
                ModifiedOn: new Date()
            }));

            const response = await fetch(APIUrl.BaseUrl + '/CategoryFilterMaster/InsertCategoryFilterMaster', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(payload)
            });

            const result = await parseJSON(response);
            if (result && (result.returnID !== undefined || result.Message === "Success")) {
                // only add saved mappings for those actually submitted (unique)
                const mappingsToAdd = selectedMappings.filter(m => unique.includes(m.ChildId));
                setsavedMappings(prev => [...mappingsToAdd, ...prev]);
                enqueueSnackbar('Mapping saved successfully', { variant: 'success' });
                // reset
                setselectedSection("");
                setselectedTypeIds([]);
                settypeSearch("");
                try { getAllCategoryFilterMaster(); } catch (e) { }
            } else {
                enqueueSnackbar('Save failed', { variant: 'error' });
            }
        } catch (error) {
            console.log(error);
            enqueueSnackbar('Error saving mapping', { variant: 'error' });
        }
    }

    const resetForm = () => {
        setselectedSection("");
        setselectedTypeIds([]);
        settypeSearch("");
    }

    const selectAllVisibleTypes = () => {
        const allIds = visibleTypes.map(x => Number(x.TypeId));
        setselectedTypeIds(allIds);
    }

    const [categoryFilters, setCategoryFilters] = useState([]);

    const getAllCategoryFilterMaster = async () => {
        try {
            const response = await fetch(APIUrl.BaseUrl + '/CategoryFilterMaster/GetAllCategoryFilterMaster', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify()
            });

            const result = await parseJSON(response);
            if (result && result.data) {
                const normalized = result.data.map(x => ({
                    FilterId: Number(x.FilterId || 0),
                    ParentId: Number(x.ParentId || 0),
                    ParentName: x.ParentName || '',
                    ChildId: Number(x.ChildId || 0),
                    ChildName: x.ChildName || '',
                    Value: x.Value || '',
                    IsActive: Boolean(x.IsActive),
                    CreatedOn: x.CreatedOn || ''
                }));
                setCategoryFilters(normalized);
            } else {
                setCategoryFilters([]);
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getAllCategoryFilterMaster();
    }, []);

    const activateDeactivateCategory = async (FilterId, action) => {
        try {
            const payload = {
                FilterId: Number(FilterId),
                Value: action,
                ModifyBy: 1
            };

            const response = await fetch(APIUrl.BaseUrl + '/CategoryFilterMaster/ActivateDeactivateCategoryFilterMaster/' + FilterId, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(payload)
            });

            const result = await parseJSON(response);
            if (result && (result.returnID !== undefined || result.Message === 'Success')) {
                enqueueSnackbar(`Successfully ${action === 'activate' ? 'activated' : 'deactivated'}`, { variant: 'success' });
                getAllCategoryFilterMaster();
            } else {
                enqueueSnackbar('Status change failed', { variant: 'error' });
            }
        } catch (err) {
            console.log(err);
            enqueueSnackbar('Error changing status', { variant: 'error' });
        }
    }

    const DeleteFilterationCategory = async (FilterId) => {
        if (!window.confirm('Are you sure you want to delete this mapping? This action cannot be undone.')) {
            return;
        }

        try {
            const response = await fetch(APIUrl.BaseUrl + '/CategoryFilterMaster/DeleteCategoryFilterMaster/' + FilterId, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                }
            });

            const result = await parseJSON(response);
            if (result && (result.returnID !== undefined || result.Message === 'Success')) {
                enqueueSnackbar('Deleted successfully', { variant: 'success' });
                getAllCategoryFilterMaster();
            } else {
                enqueueSnackbar('Failed to delete mapping', { variant: 'error' });
            }
        } catch (err) {
            console.log(err);
            enqueueSnackbar('Error deleting mapping', { variant: 'error' });
        }
    }

    const categoryColumns = [
        { name: 'Sr.No.', selector: (row, index) => index + 1, sortable: true },
        { name: 'ParentName', selector: row => row.ParentName, sortable: true },
        { name: 'ChildName', selector: row => row.ChildName, sortable: true },
        { name: 'Active', selector: row => row.IsActive ? 'Yes' : 'No', sortable: true },
        {
            name: 'Action',
            cell: row => (
                <div className="flex items-center gap-2">
                    {row.IsActive ? (
                        <button
                            onClick={() => activateDeactivateCategory(row.FilterId, 'deactivate')}
                            className="px-3 py-1 bg-gray-600 text-white text-sm rounded-md"
                        >
                            Deactivate
                        </button>
                    ) : (
                        <button
                            onClick={() => activateDeactivateCategory(row.FilterId, 'activate')}
                            className="px-3 py-1 bg-green-600 text-white text-sm rounded-md"
                        >
                            Activate
                        </button>
                    )}
                    <button
                        onClick={() => DeleteFilterationCategory(row.FilterId)}
                        className="px-3 py-1 bg-red-600 text-white text-sm rounded-md"
                    >
                        Delete
                    </button>

                </div>
            )
        }
    ];

    return (
        <div>
            <Layout>
                <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
                    <div className="space-y-6">
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                            <h2 className="text-xl font-semibold text-gray-900 mb-6">Create Filter Parent-Child Mapping</h2>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Filteration Category</label>
                                    <select
                                        ref={ZSectionInputRef}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                        value={selectedSection}
                                        onChange={(e) => setselectedSection(e.target.value)}
                                    >
                                        <option value="">-- Select Category --</option>
                                        {zsection.map(s => (
                                            <option key={s.SectionId} value={s.SectionId}>{s.SectionName}</option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Available Types (multi-select)</label>
                                    <div className="border border-gray-300 rounded-lg p-3">
                                        <div className="flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between mb-3">
                                            <input
                                                type="text"
                                                value={typeSearch}
                                                onChange={(e) => settypeSearch(e.target.value)}
                                                placeholder="Search types..."
                                                className="w-full sm:w-64 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                            />
                                            <div className="flex gap-2">
                                                <button
                                                    type="button"
                                                    onClick={selectAllVisibleTypes}
                                                    className="px-3 py-2 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200"
                                                >
                                                    Select All
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => setselectedTypeIds([])}
                                                    className="px-3 py-2 bg-gray-600 text-white text-sm font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        </div>

                                        <div className="h-52 overflow-auto pr-1">
                                            {visibleTypes.length === 0 && <div className="text-sm text-gray-500">No types found</div>}
                                            {visibleTypes.map(t => (
                                                <label key={t.TypeId} className="flex items-center justify-between px-3 py-2 mb-2 bg-gray-50 hover:bg-gray-100 rounded-lg border border-gray-200 cursor-pointer">
                                                    <span className="text-sm font-medium text-gray-700">{t.TypeName}</span>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedTypeIds.includes(Number(t.TypeId))}
                                                        onChange={() => toggleType(Number(t.TypeId))}
                                                        className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                                                    />
                                                </label>
                                            ))}
                                        </div>

                                        <div className="mt-3 text-sm text-gray-600">
                                            Selected: <span className="font-semibold text-gray-900">{selectedTypeIds.length}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row gap-4 mt-4">
                                <Button
                                    onClick={submitMapping}
                                    className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200"
                                >
                                    Save Mapping
                                </Button>
                                <Button
                                    onClick={resetForm}
                                    className="px-6 py-3 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
                                >
                                    Reset
                                </Button>
                            </div>

                            {(selectedMappings.length > 0 || savedMappings.length > 0) && (
                                <div className="mt-6 border border-gray-200 rounded-xl overflow-hidden">
                                    <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                                        <h3 className="text-base font-semibold text-gray-800">Mapped Rows (ParentId / ChildId)</h3>
                                    </div>
                                    <div className="overflow-x-auto">
                                        <table className="min-w-full divide-y divide-gray-200">
                                            <thead className="bg-white">
                                                <tr>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">ParentId</th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Filteration Category</th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">ChildId</th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">TypeName</th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-100 bg-white">
                                                {selectedMappings.map((row, index) => (
                                                    <tr key={`selected-${row.ParentId}-${row.ChildId}-${index}`} className="bg-indigo-50/40">
                                                        <td className="px-4 py-3 text-sm text-gray-800">{row.ParentId}</td>
                                                        <td className="px-4 py-3 text-sm text-gray-800">{row.ParentName}</td>
                                                        <td className="px-4 py-3 text-sm text-gray-800">{row.ChildId}</td>
                                                        <td className="px-4 py-3 text-sm text-gray-800">{row.ChildName}</td>
                                                        <td className="px-4 py-3 text-sm font-medium text-indigo-700">Ready</td>
                                                    </tr>
                                                ))}
                                                {savedMappings.map((row, index) => (
                                                    <tr key={`saved-${row.ParentId}-${row.ChildId}-${index}`}>
                                                        <td className="px-4 py-3 text-sm text-gray-800">{row.ParentId}</td>
                                                        <td className="px-4 py-3 text-sm text-gray-800">{row.ParentName}</td>
                                                        <td className="px-4 py-3 text-sm text-gray-800">{row.ChildId}</td>
                                                        <td className="px-4 py-3 text-sm text-gray-800">{row.ChildName}</td>
                                                        <td className="px-4 py-3 text-sm font-medium text-green-700">Saved</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            <div className="mt-6 bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                                <h3 className="text-base font-semibold text-gray-800 mb-4">All Category Filter Masters</h3>
                                <DataTable
                                    columns={categoryColumns}
                                    data={categoryFilters}
                                    pagination
                                    highlightOnHover
                                    responsive
                                />
                            </div>
                        </div>
                    </div>
                </main>
            </Layout>
        </div>
    )
}

export default AddFiletrationCategoryParentChild;

